import Auth from "../../lib/Auth/Auth";

window.webAuth = new Auth(
  // eslint-disable-next-line no-underscore-dangle
  window.__LENND_API_BASE_URL__,
  // eslint-disable-next-line no-underscore-dangle
  window.__LENND_APP_URL__
);
